import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "colorDress.icon-5eba35",
  "use": "colorDress.icon-5eba35-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"colorDress.icon-5eba35\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.3176 19.0894C28.9438 18.0429 28.8074 16.9263 28.9178 15.8206L30 5H25C25 7.76138 22.7615 10 20 10C17.2385 10 15 7.76138 15 5H10L11.0822 15.8206C11.1926 16.9263 11.0562 18.0429 10.6824 19.0894L5 35H35L29.3176 19.0894Z\" fill=\"#EBEBEB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol